import '@/style/HandModal.css';

const PlayermatModal = ({ playerMatPath, onClose }) => {
	const rulesmatWidth = '99%';
	// const rulesmatHeight = '18vh';

	return (
		<div className="modal" onClick={onClose}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				<h2 className="modal-title">Playermat</h2>
				<div className="hand">
					<img
						src={playerMatPath}
						alt={'playermat-img'}
						width={rulesmatWidth}
					/>
				</div>
			</div>
		</div>
	);
	// for zoom img: className="card-img"
};

export default PlayermatModal;
